import withSuspense from '../../../../common/hocs/withSuspense';
import { connect } from '../../../../storeConfig';
import InvoiceHistory from './InvoiceHistory';

// do the connect here since this component will not be placed into a Provider (it is added with react2angular) and we use redux with hooks
export default connect(undefined, {})(withSuspense(InvoiceHistory));
